import { render, staticRenderFns } from "./ResultsCandidateLog.vue?vue&type=template&id=655bd10b&lang=pug&"
import script from "./ResultsCandidateLog.vue?vue&type=script&lang=js&"
export * from "./ResultsCandidateLog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports